"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const getLargestIndustry = (concentrationReceivables) => {
    return (0, remeda_1.pipe)(concentrationReceivables, (0, remeda_1.groupBy)((receivable) => receivable.baseFields.cb_scores_fields_2_sic_2
        ? `${receivable.baseFields.cb_scores_fields_2_sic_2}`
        : 'undefined'), (0, remeda_1.mapValues)((receivables, sic2new) => {
        const totalEligibleExposure = lodash_1.default.sumBy(receivables, (receivable) => receivable.eligibilityFields.eligibleExposure);
        return {
            sic2new,
            totalEligibleExposure,
        };
    }), remeda_1.values, (0, remeda_1.sortBy)([
        (el) => el.totalEligibleExposure,
        'desc',
    ]), (0, remeda_1.first)());
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'tripActionsGoldmanSachs1.anySingleObligor',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit maxSingleObligor`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const standardBorrowingBaseReductions = lodash_1.default.map(concentrationReceivables, (receivable) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: [receivable],
                    concentrationLimitValueType,
                });
            });
            // accumulate all breaches into a single standard borrowing base reduction
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                const _result = { ...result };
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!_result[finleyReceivableId]) {
                        _result[finleyReceivableId] = 0;
                    }
                    _result[finleyReceivableId] += kickout;
                    return true;
                });
                return _result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    {
        method: 'tripActionsGoldmanSachs1.customComputerProgrammingSoftware',
        pointerImplementation: ({ concentrationReceivables, valueConfig }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit customComputerProgrammingSoftware`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const largestIndustry = getLargestIndustry(concentrationReceivables);
            // concentration limit only in effect if largest industry is business services (73)
            if (!largestIndustry || largestIndustry.sic2new !== '73') {
                return {
                    kickouts: {},
                    calculations: {
                        concentrationLimit,
                        concentrationAmount: 0,
                        concentration: 0,
                    },
                };
            }
            const businessServices = lodash_1.default.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic_2 === 73);
            const businessServicesTotalEligibleExposure = lodash_1.default.sumBy(businessServices, (receivable) => receivable.eligibilityFields.eligibleExposure);
            const customComputingProgrammingSoftware = lodash_1.default.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic === 7371 &&
                !receivable.baseFields.excluded_obligors);
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit,
                totalConcentrationExposure: businessServicesTotalEligibleExposure,
                concentrationReceivables: customComputingProgrammingSoftware,
                concentrationLimitValueType,
            });
        },
    },
    {
        method: 'tripActionsGoldmanSachs1.prePackagedSoftware',
        pointerImplementation: ({ concentrationReceivables, valueConfig }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit prePackagedSoftware`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const largestIndustry = getLargestIndustry(concentrationReceivables);
            // concentration limit only in effect if largest industry is business services (73)
            if (!largestIndustry || largestIndustry.sic2new !== '73') {
                return {
                    kickouts: {},
                    calculations: {
                        concentrationLimit,
                        concentrationAmount: 0,
                        concentration: 0,
                    },
                };
            }
            const businessServices = lodash_1.default.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic_2 === 73);
            const businessServicesTotalEligibleExposure = lodash_1.default.sumBy(businessServices, (receivable) => receivable.eligibilityFields.eligibleExposure);
            const prePackagedSoftware = lodash_1.default.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic === 7372 &&
                !receivable.baseFields.excluded_obligors);
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit,
                totalConcentrationExposure: businessServicesTotalEligibleExposure,
                concentrationReceivables: prePackagedSoftware,
                concentrationLimitValueType,
            });
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map